import React from 'react';
import PropTypes from 'prop-types';

import ProductRadio from '../../ProductRadio';

import asset from '../../assetLoader';

import ulimage from '../../assets/images/u-trapp-vanster.png';
import urimage from '../../assets/images/u-trapp-hoger.png';
import llimage from '../../assets/images/l-trapp-vanster.png';
import lrimage from '../../assets/images/l-trapp-hoger.png';

const stairTypes = {
  ul: {
    name: 'U-trappa vänstersvängd',
    image: asset(ulimage),
  },
  ur: {
    name: 'U-trappa högersvängd',
    image: asset(urimage),
  },
  ll: {
    name: 'L-trappa vänstersvängd',
    image: asset(llimage),
  },
  lr: {
    name: 'L-trappa högersvängd',
    image: asset(lrimage),
  },
};

class MeasurementsCurved extends React.Component {
  componentDidMount() {
    this.validate();
  }

  componentWillUnmount() {
    if (this.props.errors.stair_type) {
      this.props.setError('stair_type');
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.corner_bend !== this.props.corner_bend) {
      this.props.setValue('corner_bend_price', this.props.corner_bend.price.raw);
    }
  }

  validate() {
    let error = '';

    if (!this.props.values.stair_type) {
       error = 'required';
    }

    this.props.setError('stair_type', error);
  }

  getNumberOfCorners(type) {
    let number = type.indexOf('u') === 0 ? 2 : 1;

    if (this.props.values.removed_part) {
      number -= 1;
    }

    return number;
  }

  handleChange = (name, value) => {
    if (this.props.corner_bend) {
      this.props.setValue('extras', {
        ...this.props.values.extras,
        corner_bend: this.props.values.corner_bend_price * this.getNumberOfCorners(value),
      });
    }

    setTimeout(() => this.validate(), 50);    
  };

  render() {
    const { corner_bend: bend } = this.props;

    return (
      <React.Fragment>
        <h4>Välj typ av trappa</h4>

        <div id="mtm-material" className="row small-up-2 medium-up-3 mediumlarge-up-4 large-up-3 xlarge-up-4 mtm-grid">
          {Object.keys(stairTypes).map((type) => (
            <ProductRadio
              key={type}
              fieldName="stair_type"
              value={type}
              name={stairTypes[type].name}
              image={`<img src=${stairTypes[type].image} alt=${stairTypes[type].name} />`}
              price={bend && `Hörnböj ${this.getNumberOfCorners(type)} × ${bend.price.string}`}
              onChange={this.handleChange}
            />
          ))}
        </div>
      </React.Fragment>
    );
  }
}

MeasurementsCurved.propTypes = {
  values: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  corner_bend: PropTypes.object,
};

export default MeasurementsCurved;



// WEBPACK FOOTER //
// ./src/Step/steps/MeasurementsCurved.js